(function () {
	const announcementSlider = () => {
		$(".announcement-bar-onyra__slide").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			if ($(".announcement-bar-onyra")) {
				$(this).addClass("slider_started");
			}

			const announcementId = $(this).data("announcement-id");
			const autoplay = $(this).data("autoplay");
			const autoplaySpeed = ($(this).data("autoplay-speed") || 5) * 1000;
			const transitionSpeed = $(this).data("transition-speed") || 300;

			const swiperOptions = {
				loop: autoplay ? true : false,
				speed: transitionSpeed,
				navigation: {
					nextEl: `#shopify-section-${announcementId} .announcement-bar-onyra-btn-next`,
					prevEl: `#shopify-section-${announcementId} .announcement-bar-onyra-btn-prev`,
				},
			};

			if (autoplay) {
				swiperOptions.autoplay = {
					delay: autoplaySpeed,
					disableOnInteraction: false,
				};
			}

			const announcementSwiper = new Swiper(
				`.announcement-bar-onyra-js-${announcementId}`,
				swiperOptions
			);
		});
	};

	announcementSlider();
	document.addEventListener("shopify:section:load", function () {
		announcementSlider();
	});
})();
